import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {GET_CITY_ALIAS} from './actionTypes'
// import isMobileDevice from '../../utils/isMobileDevice'
// import config from '../../config'
// import getCityAliasAPI from '../../utils/get-city-alias-api'
import fetchData from '../../utils/fetch-data'

const useCityAliasActions = () => {
  const dispatch = useDispatch()
  const getCityAliasOrGroup = useCallback(
    async coords => {
      // const result = await getLatLong(value)
      const {latitude, longitude} = coords
      const url = `/event/ajax-citypage-redirect?userLat=${latitude}&userLong=${longitude}&api=1`
      const cityDataJson = await fetchData(url)

      // const cityDataJson = await getCityAliasAPI()

      dispatch({
        type: GET_CITY_ALIAS,
        payload: cityDataJson,
      })
    },
    [dispatch]
  )
  return {getCityAliasOrGroup}
}

export default useCityAliasActions
